import { Injectable } from "@angular/core";
import { addDays, isSameDay } from "@core/utils/date.utils";
import { GridColModel } from "../models/grid-col-model";
import { OrderDeliveryConfiguration } from "../models/order-delivery-configuration.model";
import { ShipmentTaskModel } from "../models/shipment-task.model";
import { DictionaryModel } from "@core/models/dictionary.model";
import { TaskTypeValueIntGroupingEnum } from "@core/enums/task-type-key.enum";
import { DaysModeEnum, PeriodsOffsetMap } from "../../_enums/days-mode.enum";


@Injectable()
export class PlannerManagerService {

  constructor() { }
  taskOrderType?: DictionaryModel[];

  public init(config: { taskOrderType?: DictionaryModel[] }) {
    if (config.taskOrderType) {
      this.taskOrderType = config.taskOrderType;
    }
  }

  public generateDaysHeaderObjects(firstDay: Date, daysMode: DaysModeEnum): Date[] {
    const repeatValue = PeriodsOffsetMap[daysMode];
    return Array.from({ length: repeatValue }, (_, index) => addDays(firstDay, index));
  }

  generateLoadingsForDays(loadings: ShipmentTaskModel[], plannerConfiguration: OrderDeliveryConfiguration): GridColModel[] {
    const displayedDays = this.generateDaysHeaderObjects(plannerConfiguration.firstDay, plannerConfiguration.daysMode);

    const result: GridColModel[] = [];

    for (const day of displayedDays) {
      let shipmentTask = loadings.filter(shipment => isSameDay(day, shipment.RealPlanDateMin)).sort(s => s.TaskTypeId) || [];
      shipmentTask = shipmentTask.sort((a, b) => this.compareShipmentsByTaskType(a, b))

      result.push({
        day: day,
        shipmentTask: shipmentTask,
      });
    }
    return result;
  }

  compareShipmentsByTaskType(a: ShipmentTaskModel, b: ShipmentTaskModel): number {
    if (!this.taskOrderType) {
      throw 'no task order type';
    }

    // jeśli oba są tego samego typu, tzn. Rozładunkowego lu Załadunkowego to porównujemy wg. kolejności w słowniku
    if (a.TaskType.ValueInt === b.TaskType.ValueInt) {
      const indexA = this.taskOrderType.findIndex(o => o.Id === a.TaskType.Id);
      const indexB = this.taskOrderType.findIndex(o => o.Id === b.TaskType.Id);

      return indexA - indexB;
    } else {
      return a.TaskType.ValueInt === TaskTypeValueIntGroupingEnum.LOADINGS ? -1 : 1;
    }
  }
}
